import React from 'react';
import { Grid, Button, Segment } from 'semantic-ui-react';

const Buttons = ({ position, fn, modal }) => {
  let dom = null;
  if (position === 'top') {
    dom = (
      <Grid className="det-form-btn">
        <Grid.Column floated="left" width={10}>
          <Button className="pwd-init-btn" inverted color="black" onClick={() => modal.onOff(true, 'small')}>비밀번호 재설정</Button>
        </Grid.Column>
        <Segment vertical />
      </Grid>
    );
  } else {
    dom = (
      <Grid className="form-btn">
        <Grid.Column floated="left" width={4}>
          <Button inverted color="black" onClick={() => fn.loginHistory(true)}>로그인 이력 확인</Button>
        </Grid.Column>
        <Grid.Column textAlign="right" width={12}>
          <Button className="cancel" inverted color="grey" onClick={() => fn.goBack()}>취소</Button>
          <Button className="ok" color="green" onClick={fn.editMyInfo}>저장</Button>
        </Grid.Column>
        <Segment vertical />
      </Grid>
    );
  }
  return dom;
};

export default Buttons;
